import { Injectable } from "@angular/core";
import { ApiServiceCall } from "../global.apiServicecall";
import { ApiUrl } from "../../constants/apiUrl";
import { Observable } from "rxjs";
import { OperationResult } from "../../models/operation-result";
import { PaymentIntent } from "@stripe/stripe-js";

@Injectable()
export class HomeService {
    constructor(
        private serviceCall: ApiServiceCall
        ) { }

    createPaymentIntent(data:any): Observable<any> {
        let _url = ApiUrl.orders + '/create-payment-intent';
        return this.serviceCall.Post(_url, true, data);
    }

    updatePaymentIntent(data:any): Observable<any> {
        let _url = ApiUrl.orders + '/update-payment-intent';
        return this.serviceCall.Post(_url, true, data);
    }

    createOrder(data:any): Observable<any> {
        let _url = ApiUrl.orders + '/create';
        return this.serviceCall.Post(_url, true, data);
    }
    createOrderPay(orderId:any, data: any): Observable<any> {
        let _url = ApiUrl.orders + `/create/${orderId}/pay`;
        return this.serviceCall.Post(_url, true, data);
    }
    orderBackup(data:any): Observable<any> {
        let _url = ApiUrl.orders + '/order_backup';
        return this.serviceCall.Post(_url, true, data);
    }
    repeatOrderPayment(data:any): Observable<any> {
        let _url = ApiUrl.orders + '/pay_unpayed_payments';
        return this.serviceCall.Post(_url, true, data);
    }

    checkPostcode(data:any): Observable<any> {
        let _url = ApiUrl.shipments + '/check_postcodes';
        return this.serviceCall.Post(_url, true, data);
    }

    checkWebView(): Observable<any> {
        let _url = ApiUrl.webview;
        return this.serviceCall.GET(_url, false, null);
    }

    handleSuccessResponse(response: any): void {
        console.log(response);
    }

    handleError(error: any): void {
        console.log(error);
    }
}